import { registerLocaleData } from '@angular/common';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatPaginatorIntl } from '@angular/material/paginator';
import localeEs from '@angular/common/locales/es';
import { provideToastr } from 'ngx-toastr';
import { provideAngularSvgIcon } from 'angular-svg-icon';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { destructiveActionInterceptor } from './core/interceptors/destructive-action.interceptor';
import { SpanishPaginatorIntl } from './core/i18n/spanish-paginator-intl';
import { ShellErrorHandler } from './core/handlers/shell-error.handler';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({
        // Add router configuration to prevent hanging
        paramsInheritanceStrategy: 'always',
        onSameUrlNavigation: 'reload'
      })
    ),
    provideHttpClient(
      withInterceptors([destructiveActionInterceptor, authInterceptor]),
      withFetch() // Enable fetch API for better performance
    ),
    provideAngularSvgIcon(),
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
    }),
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: ErrorHandler, useClass: ShellErrorHandler },
    { provide: MatPaginatorIntl, useClass: SpanishPaginatorIntl },
  ]
};
